import { PendingComments } from "pages";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: routesMap.PENDINGCOMMENTS.path,
      name: "PENDINGCOMMENTS",
      key: routesMap.PENDINGCOMMENTS.path,
      commonRoute: true,
      private: true,
      adminAccess: true,
      element: <PendingComments />,
    },
    {
      path: `${routesMap.PENDINGCOMMENTS.path}/:id`,
      name: "PENDINGCOMMENTS",
      key: `${routesMap.PENDINGCOMMENTS.path}/:id`,
      commonRoute: true,
      private: true,
      adminAccess: true,
      element: <PendingComments />,
    },
  ];
}
